import styled from '@emotion/styled';

import { animationFade } from '../../../theme/animations/animationFade';
import { su } from '../../../theme/functions/su';
import { motion } from '../../../theme/motion';
import { theme } from '../../../theme/theme';

import { Clipboard } from '../../../components/common/Clipboard';
import { Heading3Medium } from '../../../components/common/text/Heading3Medium';
import { TextSmall } from '../../../components/common/text/TextSmall';

export function GeneralSettingsSection() {}
function S() {}
GeneralSettingsSection.S = S;

S.Section = styled.section`
  padding-bottom: ${su(2)};
`;

S.SectionView = styled.div`
  position: relative;
  width: 440px;
  padding: ${su(1)} ${su(2)};
  border-radius: ${theme.borderRadius.default};
  box-shadow: ${theme.boxShadow.default};
  background-color: ${theme.color.component};
`;

S.SectionHeading = styled(Heading3Medium)`
  padding: ${su(2)} 0 ${su(1)};
`;

S.SubSection = styled.section`
  padding-bottom: ${su(2)};
`;

S.SubSectionHeading = styled(TextSmall)`
  color: ${theme.color.text_light};
  padding-bottom: 5px;
`;

S.Row = styled.div`
  display: grid;
  align-items: center;
  min-height: ${su(5)};
  gap: ${su(2)};
  grid-template-columns: auto 1fr;
  min-width: 0;
`;

S.Label = styled.div``;

S.Value = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${theme.color.text_light};
  word-break: break-word;
  text-align: end;
  min-width: 0;

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  > *:not(:first-child) {
    margin-inline-start: 4px;
  }

  ${Clipboard.S.Root} {
    flex: 1;
  }
`;

S.FadeInWrapper = styled.div`
  opacity: 0;
  animation-name: ${animationFade.in};
  animation-duration: ${motion.duration.normal};
  animation-timing-function: ${motion.curve.ease_out};
  animation-fill-mode: forwards;
`;

S.Center = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
